import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const FAQs = () => {
  return (
    <div className="intro">
      <h2>
        <a>
          {" 常见问题 "}
          <small>FAQs</small>
        </a>
      </h2>

      <div className="faqs-container">
        {/* 问题 1 */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>全国的GDP增速是如何预测的？</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              全国 GDP
              增速的预测基于北大汇丰智库构建的高频动态预测模型，主要参考纽约联储提出的
              WEI（Weekly Economic
              Index）方法。模型采用生产法思路，使用一系列高频宏观与行业指标实时预测季度
              GDP 当季同比增速。
              核心指标包括：猪肉平均批发价格、南华工业品指数、义乌小商品价格总指数、30
              大中城市商品房成交套数、SCFI
              综合指数等，覆盖农业、工业、消费、房地产与交运等多个领域。模型解释变量涵盖季度、周度、日度数据，能有效捕捉当季经济运行态势。
              对于当前季度的 GDP 增速预测，WEI
              模型可基于已公布的高频指标动态更新，预测效果较好。对于下一季度的预测，由于数据滞后，需对解释变量进行
              AR(2) 自回归外推，预测结果可能受更大不确定性影响。因此，本平台结合
              WEI 模型预测本季度 GDP
              增速，并使用“环比同比外推法”估算下一季度增长率。
            </Typography>
          </AccordionDetails>
        </Accordion>
        {/* 问题 2 */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>珠三角9个城市的GDP增速是如何预测的？</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              在对珠三角9市的 GDP
              增速进行预测时，我们主要采用北大汇丰智库所研发的基于计量经济模型前沿方法的动态因子模型（Dynamic
              Factor Model, DFM），用于实现经济活动的
              Nowcasting（实时预测）。具体方法上，我们利用多频率、多领域的城市经济指标数据，借助动态因子提取等技术，对季度
              GDP
              当季同比进行实时更新预测。所使用的数据涵盖地铁客运量、电影票房、PMI、价格指数、投资、消费、房地产成交、进出口、旅游入境人数等多个方面，频率横跨周度、月度与季度，模型可随着数据陆续发布进行滚动校正与增强。相比其他区域，我们未在珠三角九市预测中使用机器学习方法，而是依托结构明确、可解释性强的动态因子模型，以捕捉城市群经济的系统性共变特征。
            </Typography>
          </AccordionDetails>
        </Accordion>
        {/* 问题 3 */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>广东和深圳的主要经济指标增速是如何预测的？</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              广东和深圳的主要经济指标增速程预测是采用了萨金特数量经济研究所研发的
              Nowcasting
              方法。因使用到的模型与数据集与珠三角9个城市不同，因此分开发布供参考。
            </Typography>
          </AccordionDetails>
        </Accordion>
        {/* 问题 4 */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>什么是Nowcasting？</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Nowcasting（实时预测）是一种用于当前或短期未来的预测技术，
              通过高频数据来反映经济活动的动态，为政府决策和学术研究提供支持。“预测”的目标是跟踪当前和最近的未来。例如，我们在
              2024 年第一季度预测2024年第一季度的
              GDP。当我们进行预测时，生成当季 GDP
              的过程已经在进行，但是这个数字要滞后相当时间才能被算出和公布。从这个意义上说，我们的练习实际上并不是一个严格的“预测”，而是试图从一大堆信息中揭示一个潜在的并发变量。也就是说，我们正在了解当前经济的真实状态，而不是预测未来的状态。出于这个原因，文献将这种练习称为现测（Nowcasting）。鉴于我们所做的预测的短期性质，在本网站中，预测和现测这两个术语将被交替使用。
            </Typography>
          </AccordionDetails>
        </Accordion>

        {/* 问题 5 */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>
              针对广东和深圳的Nowcasting预测是基于什么模型？
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              我们在预测中使用两种类型的模型，分别代表计量经济模型和机器学习模型的前沿方法。
              在线性计量经济模型中，我们使用的主要是基于动态因子模型(DFM)发展出的新方法，包括动态渐进主成分回归、监督因子模型和监督动态主成分分析。在基于机器学习的模型中，循环神经网络(Recurrent
              Neural Networks,
              RNN)模型是我们的首选，同时，我们也使用了预测文献中常用的其他6种机器学习方法作为比较，包括三种正则化回归模型：最小绝对收缩和选择算子（Least
              Absolute Shrinkage and Selection Operator,
              LASSO），岭回归（Ridge），弹性网（Elastic
              Net）；两种树模型：随机森林（Random
              Forest）和极端梯度提升（XGBoost），以及支持向量回归（Support
              Vector Regression,
              SVR）。这些模型是基于我们对当前经济预测文献的最佳理解选择的。最终预测是通过动态模型平均方法进行的复合预测。
            </Typography>
          </AccordionDetails>
        </Accordion>

        {/* 问题 6 */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>
              使用哪些数据进行针对广深经济指标增速的Nowcasting？
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              当前研究使用多种公开来源的数据，包括大量的宏观经济和微观经济数据，涵盖了中国区
              域的经济指标。对于预测建模任务，我们关注的数据集对应于广东省和深圳市两个行政层级。
              我们收集了广东的 1133 个变量和深圳的 1209 个变量。这些变量涵盖了
              GDP、就业数据、金融数据、工业生产、消费者指标和人口统计数据。它们还包含了区域微观数据，如客运量、交通和企业。值得注意的是，这些变量可得的频率不尽相同，包括年度、季度和月度数据点。
              数据预处理主要包括三个部分：数据清洗、插值和平稳化处理。
            </Typography>
          </AccordionDetails>
        </Accordion>

        {/* 问题 7 */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Nowcasting和传统经济预测的区别是什么？</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Nowcasting 依赖于高频大数据和先进的计量经济学/机器学习方法，
              能够更快反映经济变化，相较传统经济预测，北大汇丰Nowcasting模型对数量信息的覆盖更加全面及时。
            </Typography>
          </AccordionDetails>
        </Accordion>

        {/* 问题 8 */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Nowcasting模型可以用于区域经济分析吗？</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              可以。我们的研究证明，由于区域经济的波动性高于全国，使用更精密的大数据模型可以显著降低预测误差。目前已经建立了广东省、深圳市的Nowcasting预测，并计划扩展到其他主要城市和经济区。
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
};

export default FAQs;
